import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { map, uniqueId } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Icons, TextField, Select, SelectOption, TextArea, FlexRow, FlexCol, Box } from 'sarsaparilla';
import { addChange, clearChange, getRef } from '../../actions/changes';
import { LinkProps } from '../../props/link';

const propTypes = {
    value: LinkProps,
    linkType: PropTypes.string,
    onRemove: PropTypes.func,
    getRef: PropTypes.func.isRequired,
    addChange: PropTypes.func.isRequired,
    clearChange: PropTypes.func.isRequired
};

const linkTypeOptions = [
    { label: 'Select Type', value: '' },
    { label: 'Concessionaires', value: 'Concessionaires' },
    { label: 'Equipment Rental', value: 'Equipment Rental' },
    { label: 'Facebook', value: 'Facebook' },
    { label: 'Flickr', value: 'Flickr' },
    { label: 'Google+', value: 'Google+' },
    { label: 'Local Partnerships', value: 'Local Partnerships' },
    { label: 'Map', value: 'Map' },
    { label: 'Official Web Site', value: 'Official Web Site' },
    { label: 'Reservation', value: 'Reservation' },
    { label: 'Twitter', value: 'Twitter' },
    { label: 'Virtual Tours', value: 'Virtual Tours' },
    { label: 'YouTube Channel', value: 'YouTube Channel' },
    { label: 'Other', value: 'Other' }
];

export class LinkEdit extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            record: this.props.value,
            ref: this.props.getRef(
                this.props.linkType,
                { id: this.props.value.id },
                0,
                ['url', 'title'].reduce((m, f) => Object.assign(m, { [f]: props.value[f] }), {})
            )
        };

        this.handleChange = this.handleChange.bind(this);
        this.doRemove = this.doRemove.bind(this);
    }

    handleChange(event) {
        const { dataset: { field }, value } = event.target;

        const change = { [field]: value };

        this.setState((prevState) => ({
            ...prevState,
            record: { ...prevState.record, ...change }
        }), () => this.props.addChange(this.state.ref, change));
    }

    doRemove() {
        if (this.props.value.id) {
            this.props.addChange(this.state.ref, { _delete: true });
        }
        else {
            this.props.clearChange(this.state.ref);
        }
        this.props.onRemove(this.props.value._key);
    }

    render() {
        const { value } = this.props;

        const {
            id,
            type,
            url,
            title,
            description
        } = value;

        return (
            <Box
                padding="md"
                border="gray"
                background="white"
                marginY="md">

                <Button
                    appearance="subtle-danger"
                    onClick={this.doRemove}
                    iconBeforeElement={<Icons.IconClose />} />

                <FlexRow>
                    <FlexCol xs={12} lg={6}>
                        <Select
                            id={`link-type-${id}`}
                            className="mb-1"
                            label="Link Type"
                            value={type}
                            onChange={this.handleChange}
                            isRequired>
                            { map(linkTypeOptions, (option) => (
                                <SelectOption key={uniqueId()} value={option.value}>{option.label}</SelectOption>
                            ))}
                        </Select>

                        <TextField
                            id={`link-url-${id}`}
                            className="mb-1"
                            label="Link URL"
                            value={url}
                            onChange={this.handleChange}
                            isRequired />
                    
                        <TextField
                            id={`link-text-${id}`}
                            className="mb-1"
                            label="Link Text"
                            value={title}
                            onChange={this.handleChange}
                            isRequired />
                    </FlexCol>

                    <FlexCol xs={12} lg={6}>
                        <TextArea
                            id={`link-description-${id}`}
                            className="mb-1"
                            label="Link Description"
                            value={description}
                            onChange={this.handleChange}
                            isRequired />
                    </FlexCol>
                </FlexRow>
            </Box>
        );
    }
}

LinkEdit.propTypes = propTypes;

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getRef,
    addChange,
    clearChange
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LinkEdit);
